import {
  IConversationMessage,
  ISentMessage,
} from "../../../types/webchatConversation";
import {
  ADD_NEW_MESSAGE_SUCCESS_IN_CHAT_LIST,
  CLEAR_CHAT_MESSAGES,
  GET_CONVERSATION_SUCCESS,
  HIDE_TYPING_INDICATOR,
} from "../constants";

export const ChatMessages = (
  state: (IConversationMessage | ISentMessage)[] = [],
  action,
) => {
  switch (action.type) {
    case ADD_NEW_MESSAGE_SUCCESS_IN_CHAT_LIST: {
      const newMessage: IConversationMessage = action.payload.message;
      const { notDelivered } = newMessage;
      if (notDelivered !== undefined) {
        let newMsgAdded = false;
        const chatMessages = [...state].map((message) => {
          if (
            message.sentMsg &&
            message.msg.text === newMessage.msg.text &&
            !newMsgAdded
          ) {
            newMsgAdded = true;
            return newMessage;
          } else {
            return message;
          }
        });

        return [...chatMessages];
      }
      // Ako je nova poruka sa leve strane (bot/AI), sakrij typing indicator
      // Proveri placement - ako je "left", to je bot poruka
      return [...state, newMessage];
    }
    case GET_CONVERSATION_SUCCESS: {
      const previousMessages: IConversationMessage[] =
        action.payload.conversationMessages;
      return [...state, ...previousMessages];
    }
    case CLEAR_CHAT_MESSAGES:
      return [];
    default:
      return [...state];
  }
};
